import { Navigate,useLocation } from "react-router";
import { useAuth } from "../../contexts/auth/useAuth";
import type { JSX } from "react";
import { type rolesList } from "../../types/Users";

export  const  RoleRoute = ( {role,children}: {role:rolesList ,children: JSX.Element} ) => {
  //const [isAuth, setIsAuth] = useState<boolean>(); // initially undefined
  const {isAuthenticated,isLoading,hasRole,userRole} = useAuth();

  const location = useLocation();

  if (isLoading) {
      // Still verifying token—show a spinner or message
      return <div>Loading authentication status…</div>;
    }

  //if(!isAuth) return null;
  return isAuthenticated && hasRole(role) ? children : 
  <Navigate to="/login" state={{from: location,error:"permission",role:userRole}} />;

};
export default RoleRoute;